import React, { useState, useEffect, useContext } from 'react';
import './SolFilter.scss';
import { FilterStore } from '../../../../App';

export default () => {
  const currentFilter = useContext(FilterStore).filter;

  const [fromSol, setFromSol] = useState(currentFilter.fromSol ? currentFilter.fromSol : '');
  const [toSol, setToSol] = useState(currentFilter.toSol ? currentFilter.toSol : '');

  const { changeSol } = useContext(FilterStore).actions;

  useEffect(() => {
    const tempFrom = parseInt(fromSol);
    const tempTo = parseInt(toSol);
    if (tempFrom > 0 && tempTo > 0 && tempFrom < tempTo) {
      changeSol(tempFrom, tempTo);
    } else {
      changeSol(null, null);
    }
    
  }, [fromSol, toSol]);

  return (
    <div className="filter-item">
      <h2 className="filter-item__headline">Sol</h2>

      <div className="sol-select">
        <div className="earth-date__item sol-select__item">
          <h3 className="earth-date__item__label sol-select__item__label">From</h3>
          <input
            onChange={(e) => setFromSol(e.target.value)}
            type="text"
            value={fromSol}
            className="sol-select__item__input"
            placeholder="200"
          />
        </div>
        <div className="earth-date__item sol-select__item">
          <h3 className="earth-date__item__label sol-select__item__label">To</h3>
          <input
            onChange={(e) => setToSol(e.target.value)}
            type="text"
            value={toSol}
            className="sol-select__item__input"
            placeholder="300"
          />
        </div>
      </div>
    </div>
  )
}